import React from 'react';
import styles from "Styles/TwoColumnInput.module.css";

const TwoColumnInput = ({...props}) => {
  return (
    <div className={styles.twoColumnInput}>{props.children}</div>
  )
}

export default TwoColumnInput